import React, {PureComponent} from 'react';
import SwiperCore from 'swiper';
import {Swiper} from 'swiper/swiper-react';
import {Navigation, Pagination} from 'swiper/modules';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

const swiperParams = {
    allowTouchMove: true,
    freeMode: {
        momentum: false,
        momentumBounce: false
    },
    observeParents: true,
    observer: true,
    slidesPerGroup: 2,
    speed: 400,
    touchRatio: 0.65,
    touchReleaseOnEdges: false,
    touchStartForcePreventDefault: true
};

interface PreviewGamesListProps {
    isSwiper: boolean
    onCheckReached?: (swiper: SwiperCore) => void
    children?: React.ReactNode
}

export default class PreviewGamesList extends PureComponent<PreviewGamesListProps> {
    render(): React.ReactNode {
        const {children, onCheckReached} = this.props;

        return this.props.isSwiper
            ? <>
                <Swiper className="slider-container-swiper" {...swiperParams}
                    slidesPerView="auto"
                    freeMode
                    preventInteractionOnTransition
                    preventClicksPropagation
                    resistance={false}
                    watchSlidesProgress
                    onTouchEnd={onCheckReached}
                    onAfterInit={onCheckReached}
                    modules={[Pagination, Navigation]}
                    pagination={{
                        clickable: true,
                        el: '.pagination-preview'
                    }}
                    navigation={{
                        nextEl: '.button-preview-next',
                        prevEl: '.button-preview-prev'
                    }}>{children}</Swiper>
                <div className="slider-pagination-control">
                    <button className="swiper-button-slider-prev button-preview-prev">
                        <SpriteIcon name="#svg-swiper-arrow" className="svg-default"/>
                    </button>
                    <div className="swiper-pagination-group pagination-preview"/>
                    <button className="swiper-button-slider-next button-preview-next">
                        <SpriteIcon name="#svg-swiper-arrow" className="svg-default"/>
                    </button>
                </div>
            </>
            : <div className="slider-container-free">{children}</div>;
    }
}
